import { Outlet } from "react-router-dom";
import Sidebar from "@/components/shell/Sidebar";
import Topbar from "@/components/shell/Topbar";

export default function AppShell() {
    return (
        <div className="min-h-screen bg-[#f5f5f4] text-[#18181b]">
            <Sidebar />
            <div className="ml-64 min-h-screen flex flex-col">
                <Topbar />
                <main className="flex-1 p-8" data-testid="main-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
